import React from "react";
import CustomTooltip from "../../common/CustomTooltip";
import DisplayError from "../../common/DisplayError";
import "./EmailField.css";
import type { StandardFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

const VALIDATE_DOMAIN_ERROR_TYPE = "validateEmailDomainChecker";

const EmailField: React.FC<StandardFieldProps> = (props) => {
  const form = useFormContext();
  const { register } = form;
  return (
    <React.Fragment>
      <div>
        <label htmlFor={props.name} className={"hidden"}>
          {props.name}
        </label>
        <CustomTooltip
          conditionToShow={props?.error?.type === VALIDATE_DOMAIN_ERROR_TYPE}
          tooltip={<span>{props?.error?.message}</span>}
        >
          <input
            id={props.name}
            type={props.type || "text"}
            className="form-control"
            placeholder={props.placeholder}
            {...register(props.name, props.validationsObject)}
          />
        </CustomTooltip>
      </div>
      <DisplayError
        errorCondition={
          props.error && props.error.type !== VALIDATE_DOMAIN_ERROR_TYPE
        }
        errorMessage={props.error && props.error.message}
      />
    </React.Fragment>
  );
};

export default EmailField;
